import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "preview", "container", "placeholder"]

  connect() {
    console.log("Video preview controller connected")
  }

  preview() {
    const file = this.inputTarget.files[0]
    if (!file) return

    // Ensure it's a video
    if (!file.type.startsWith('video/')) {
      alert('Please select a valid video file.')
      this.inputTarget.value = ''
      return
    }

    const url = URL.createObjectURL(file)
    
    // Show the preview container and hide the placeholder
    this.containerTarget.classList.remove('hidden')
    this.placeholderTarget.classList.add('hidden')
    
    // Set the video source
    this.previewTarget.src = url
    this.previewTarget.load()
    this.previewTarget.play().catch(e => console.log("Auto-play prevented"))
  }

  remove(event) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }

    this.inputTarget.value = ''
    this.containerTarget.classList.add('hidden')
    this.placeholderTarget.classList.remove('hidden')
    this.previewTarget.src = ''
  }
}
